export var DEFAULT_OVERLAY_CLASS_NAME = 'dynamic-tile-overlay';
export var DEFAULT_TILE_CLASS_NAME = 'dynamic-tile-item';
export var TILE_CONTENT_GROUP_CLASS_NAME = 'dynamic-tile-element-group';
export var TILE_CONTENT_TYPE_MARKDOWN = 'MARKDOWN';
export var TILE_CONTENT_TYPE = {
  CONTENT: 'content',
  MARKDOWN: 'markdown',
  INTERACTION: 'interaction'
};